import { render, staticRenderFns } from "./PromoCodeManagement.vue?vue&type=template&id=6c10ac66"
import script from "./PromoCodeManagement.vue?vue&type=script&lang=js"
export * from "./PromoCodeManagement.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeManagement.vue?vue&type=style&index=0&id=6c10ac66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports